module.exports = __webpack_public_path__ + "img/ProjectDetailOverlay.958b2a02.png";